import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { ResponseState } from '../../models/support/response-state';
import { ClientBalanceService } from '../../services/balances/client-balance.service';
import { SharedService } from '../../services/other/shared.service';
import { TransactionsSecondService } from '../../services/transaction/transactions-second.service';
import { GiftCardInformation } from 'src/app/models/classes/gift-cards/gift-card-information';
import { GiftCardInformationService } from 'src/app/services/gift-card/gift.card.information.service';
import { GiftCardInformationUsingDetail } from 'src/app/models/classes/gift-cards/gift-card-information-using-detail';
import { GiftCardInformationBranch } from 'src/app/models/classes/gift-cards/giftCardInformationBranch';
import { ToastrService } from 'ngx-toastr';
import { Company } from '../../models/classes/company/company';
import { GiftCardInformationOTP } from '../../models/classes/gift-cards/gift-card-information-otp';
import { UpdateItemNumberModel } from 'src/app/models/classes/booking/update-item-number-model';
import { UpdateItemNumberType } from 'src/app/models/enums/update-item-number-type';
import { ABookingService } from 'src/app/services/booking/abooking.service';
import { BookingService } from 'src/app/dashboard/bookings/service/booking.service';
import { PaidStatus } from 'src/app/models/enums/paid-status';
import { BookingStatus } from 'src/app/models/enums/booking-status';
import { AddedByDevice } from 'src/app/models/enums/added-by-device';
import { CheckRequestPermissionComponent } from 'src/app/dashboard/appointment/ui/check-request-permission/check-request-permission.component';
import { BookingOrTransactionItemType } from 'src/app/models/enums/booking-or-transaction-item-type';
import { RequestPermissionNotificationItem } from 'src/app/models/classes/notification/request-permission-notification-item';
import { ClientPackage } from 'src/app/models/classes/client/client-service';
import { BookingServiceClass } from 'src/app/dashboard/bookings/models/booking-service';
import { RequestPermissionNotificationType } from 'src/app/models/enums/request-permission-notification-type';
import { RequestPermissionNotificationModel } from 'src/app/models/classes/notification/request-permission-notification-model';
import { OTPResponse } from 'src/app/models/classes/transactions/transaction-otp-response';
import { ModalHandleTransactionOTPComponent } from 'src/app/dashboard/transactions/ui/modal-handle-transaction-otp/modal-handle-transaction-otp.component';
import { HubConnectionState } from '@microsoft/signalr';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { RequestPermissionNotificationStatus } from 'src/app/models/enums/request-permission-notification-status';
import { NewReplyPermissionNotificationModel } from 'src/app/models/classes/signal-r/new-reply-permission-notification-model';
import { MagicStrings } from 'src/app/models/const/magic-strings';
import { ApplicationType } from 'src/app/models/enums/application-type';
import { Booking } from 'src/app/models/classes/booking/booking';

@Component({
  selector: 'app-modal-calendar-event-info',
  templateUrl: './modal-calendar-event-info.component.html',
  styleUrls: ['./modal-calendar-event-info.component.scss'],
  providers: [DatePipe],
})
export class ModalCalendarEventInfoComponent implements OnInit {


  @Input() GiftCardInformationId: number;
  @Input() GiftCardCode: string;

  @Input() CalendarEvent: any;
  @Input() CalendarType: any;
  @Input() IsNewLiteApi: boolean = false;
  @Input() BookingId: number;

  @Output() public RefreshView = new EventEmitter<boolean>();
  @Output() public GetNextBookingsOnly = new EventEmitter<boolean>();
  @Output() public OpenModalPayment = new EventEmitter<any>();
  @Output() public OpenModalClientDownPayment = new EventEmitter<any>();

  public DefaultAccountCurrencyName: string;
  public GiftCardInformationUsingDetails: GiftCardInformationUsingDetail[];
  public GiftCardInformationOTPs: GiftCardInformationOTP[];
  public GiftCardInformationBranches: GiftCardInformationBranch[];
  public LoadingGetGiftCardUsingDetails: boolean = false;
  public LoadingGetGiftCardOTPCodes: boolean = false;
  public LoadingGetGiftCardBranches: boolean = false;
  public freeTextGetGiftCardBranches: string;
  public freeTextGetGiftCardUsingDetails: string;
  public freeTextGetGiftCardOTPCodes: string;
  public GiftCardInformation: GiftCardInformation;
  public Company: Company;
  public LoadingEditItemNumber: boolean;
  public UpdateBookingStatusLoading: boolean = false;
  public ClientNotificationsOTPError: boolean = false;
  private hubConnection: signalR.HubConnection;
  public bookingStatus: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public sharedService: SharedService,
    private bookingService: BookingService,
    private aBookingService: ABookingService,
    public _transactionsSecondService: TransactionsSecondService,
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    private signalRService: SignalRService,
    private ngbModal: NgbModal,
    @Inject(LOCALE_ID) private locale: string,
    public toaster: ToastrService,
    public giftCardInformationService: GiftCardInformationService,
    public clientBalanceService: ClientBalanceService
  ) { }

  ngOnInit(): void {
    this.Company = this.sharedService.CurrentCompany;
    this.DefaultAccountCurrencyName =
      this.translate.currentLang == 'ar'
        ? this.sharedService.CurrencyNameAr
        : this.sharedService.CurrencyNameEn;
    this.convertEnumToArray();

    if (this.IsNewLiteApi && this.BookingId > 0) {
      this.GetOneBookingForDayView();
    }
  }
  public get updateItemNumberType(): typeof UpdateItemNumberType {
    return UpdateItemNumberType;
  }
  public get paidStatus(): typeof PaidStatus {
    return PaidStatus;
  }
  public get bookingStatusEnum(): typeof BookingStatus {
    return BookingStatus;
  }
  public get addedByDevice(): typeof AddedByDevice {
    return AddedByDevice;
  }

  GetOneBookingForDayView() {

    let criteria = {
      AccountSetupId: this.sharedService.AccountSetupId,
      BookingId: this.BookingId
    };

    this.bookingService
      .GetBookingsForDayView(criteria)
      .subscribe((response: any) => {

        if (response.State == ResponseState.Success) {

          let booking: Booking = response.Bookings && response.Bookings.length > 0 ?
            response.Bookings[0] : null;

          let bookPlace: string = null;
          let AddedBy: string = null;

          if (booking) {

            if (booking.BookingPlace === 1) {
              bookPlace = this.translate.instant('InHome');
            } else {
              bookPlace = null;
            }

            if (booking.AddedAppId === ApplicationType.Glamera) {
              AddedBy = 'جلاميرا ';
            } else if (booking.AddedAppId === ApplicationType.GlameraBusinessMobile) {
              AddedBy = 'جلاميرا بزنس موبيل ';
            } else if (booking.AddedAppId === ApplicationType.GlameraBusinessWeb) {
              AddedBy = ' جلاميرا بزنس ويب';
            } else if (booking.AddedAppId === ApplicationType.Glamatek_AdminPanel) {
              AddedBy = 'جلاماتك ادمن  ';
            } else if (booking.AddedAppId === ApplicationType.GentleApp) {
              AddedBy = 'GentleApp   ';
            } else if (booking.AddedAppId === ApplicationType.Diva) {
              AddedBy = 'Diva   ';
            } else if (booking.AddedAppId === ApplicationType.Elixir) {
              AddedBy = 'Elixir   ';
            } else if (booking.AddedAppId === ApplicationType.Aram) {
              AddedBy = 'Aram    ';
            }
            for (let s = 0; s < 1/*booking.BookingServices.length*/; s++) {

              let serviceName =
                this.translate.currentLang == 'ar'
                  ? booking.BookingServices[s].Service.NameAr
                  : booking.BookingServices[s].Service.NameEn;

              if (booking.BookingServices[s]) {

                this.CalendarEvent = {
                  Id: booking.Id,
                  bookingServiceId: booking.BookingServices[s].Id,
                  itemNumber: booking.BookingServices[s].ItemNumber,
                  newItemNumber: booking.BookingServices[s].ItemNumber,
                  idbs: booking.BookingServices[s].Id,
                  color: null,

                  start: new Date(booking.BookingServices[s].Date),
                  end: new Date(
                    new Date(
                      booking.BookingServices[s].Date
                    ).getTime() +
                    booking.BookingServices[s].Service
                      .BookingMinutes *
                    60000
                  ),

                  title:
                    (this.sharedService.CurrentBranch.AllowTheUseOfTheBookingServicesNumberingSystem &&
                      booking.BookingServices[s].ItemNumber > 0 ?
                      ("<span class='booking-item-number'> &nbsp;" + booking.BookingServices[s].ItemNumber +
                        "&nbsp;</span>") + " " : "") +

                    booking.Id +
                    /* isPayOnline + */
                    ' - ' +
                    booking.Client.Name +
                    ' - ' +
                    serviceName +
                    ' - ' +
                    booking.BookingServices[s].TotalNetPrice.toFixed(this.sharedService.GetFractionRoundCount) +
                    ' ' +
                    this.DefaultAccountCurrencyName +
                    (bookPlace ? ' - ' + bookPlace : ''),

                  ClientId: booking.Client.Id,
                  ItemType: null,
                  name: booking.Client.Name,
                  mobile: booking.Client.Mobile,
                  service:
                    this.translate.currentLang == 'ar'
                      ? booking.BookingServices[s].Service.NameAr
                      : booking.BookingServices[s].Service.NameEn,
                  emp1: booking.BookingServices[s].Employee?.NameAr,
                  emp2:
                    booking.BookingServices[s]?.SecondEmployee
                      ?.NameAr || '',
                  status: booking.BookingStatusDesc,
                  IsPaid: booking.IsPaid,
                  comment: booking.Comment,
                  bookingPlace: booking.BookingPlace,
                  EnablePayment: booking.EnablePayment,
                  ItemPrice: booking.BookingServices[s].TotalNetPrice,
                  ItemDateAndTime: booking.BookingServices[s].Date,
                  TotalAmount: booking.TotalAmount,
                  AddedAppId: booking.AddedAppId,
                  bookingNotes: booking.BookingNotes,
                  bookingServiceImages:
                    booking?.BookingServices[s]
                      ?.BookingServiceImages ?? [],
                  RequestPermissionNotificationId: null,
                  BookingStatus: booking.BookingStatus,
                  OriginalBookingStatus: booking.BookingStatus,
                  meta: {
                    user: {
                      id: this.CalendarType
                        ? booking?.BookingServices[s]
                          ?.ResourceManagements[0]?.ResourceId
                        : booking?.BookingServices[s]?.Employee?.Id,
                      name: this.CalendarType
                        ? booking?.BookingServices[s]
                          ?.ResourceManagements[0]?.ResourceName
                        : booking?.BookingServices[s]?.Employee
                          ?.NameAr,
                      NameEn: this.CalendarType
                        ? booking?.BookingServices[s]
                          ?.ResourceManagements[0]?.ResourceName
                        : booking?.BookingServices[s]?.Employee
                          ?.NameEn,
                      color: 'yellow',
                    },
                  },
                  AccountSetupId: booking.AccountSetupId,
                  Date: booking.Date,
                  BookingServices: booking.BookingServices,
                  ClientPackages: booking.ClientPackages,
                  clientAddress: booking.ClientAddress,
                  clientAddressText: booking.ClientAddressText,
                  AddedDate: booking.AddedDate,
                  UserName: booking.UserName,
                  AddedByDevice: booking.AddedByDevice,
                  ClientAddress: booking.ClientAddress,
                  GymGroupStartDate: booking.BookingServices[s].Service.StartDate,
                  GymGroupEndDate: booking.BookingServices[s].Service.EndDate,
                  GroupSessions: booking.BookingServices[s].Service.GroupSessions
                };
              }
            }
          } else {
            this.toaster.error(this.translate.instant('Sorry!!BookingNotFound!'));
          }
        }
      });
  }

  editItemNumber(event: any, updateItemNumberType: UpdateItemNumberType) {

    this.LoadingEditItemNumber = true;

    var model = new UpdateItemNumberModel();
    model.BookingServiceId = event.bookingServiceId;
    model.NewItemNumber = event.newItemNumber;
    model.UpdateItemNumberType = updateItemNumberType;

    this.aBookingService.UpdateItemNumber(model).subscribe((response: any) => {
      if (response.State == ResponseState.Success) {
        this.toaster.success(this.translate.instant('DoneChangeItemNumberSuccessfully'));
        this.CalendarEvent.itemNumber = event.newItemNumber;
        this.RefreshView.emit(true);
      }
      this.LoadingEditItemNumber = false;
    });

  }
  message = {
    sms: null,
  };

  openModalPayment() {
    this.OpenModalPayment.emit(this.CalendarEvent);
  }
  openModalClientDownPayment() {
    this.OpenModalClientDownPayment.emit(this.CalendarEvent);
  }

  SendManualSms(modalData) {
    this.bookingService
      .SendManualSms({ ClientId: modalData, Sms: this.message.sms })
      .subscribe((response: any) => {
        if (response.State == ResponseState.Success) {
          this.sharedService.ToastrSuccess(response.Message);
          this.message.sms = '';
        } else {
          this.sharedService.ToastrError(response.Message);
        }
      });
  }

  show = false;
  UpdateBookingStatus(e, booking: Booking) {


    var oldBookingStatus = booking.OriginalBookingStatus;

    if (this.CheckForNotifyClientOTP(booking)) {
      this.openModalHandleBookingOTPComponent(e, booking);
    } else {


      booking.BookingStatus = e?.target?.value ?? booking.BookingStatus;
      var bookingStatusModel: Booking = new Booking();

      bookingStatusModel.Id = booking.Id;
      bookingStatusModel.AccountSetupId = booking.AccountSetupId;
      bookingStatusModel.ClientId = booking.ClientId;
      bookingStatusModel.Date = booking.Date;
      bookingStatusModel.IsPaid = booking.IsPaid;
      bookingStatusModel.ClientNotificationOTPId = booking.ClientNotificationOTPId;
      bookingStatusModel.BookingOTPCode = booking.BookingOTPCode;
      bookingStatusModel.BookingStatus = booking.BookingStatus;
      bookingStatusModel.RequestPermissionNotificationId =
        booking.RequestPermissionNotificationId;
      bookingStatusModel.BookingServices = booking.BookingServices;
      this.UpdateBookingStatusLoading = true;

      this.bookingService
        .UpdateBookingStatus(bookingStatusModel)
        .subscribe((response: any) => {

          this.UpdateBookingStatusLoading = false;
          if (response.State == ResponseState.Success) {
            this.sharedService.ToastrSuccess(response.Message);
            this.RefreshView.emit(true);
            this.GetNextBookingsOnly.emit(true);
            this.ngbModal.dismissAll();
          } else if (response.State == ResponseState.ActionNotAllowed) {
            this.show = true;

            var requestPermissionNotificationModel =
              new RequestPermissionNotificationModel();
            requestPermissionNotificationModel.BookingOrTransactionClientId =
              booking.ClientId;

            requestPermissionNotificationModel.BookingOrTransactionTotalPrice =
              booking.TotalAmount;

            requestPermissionNotificationModel.BookingId = booking.Id;

            requestPermissionNotificationModel.BookingDateTime =
              bookingStatusModel.Date;
            requestPermissionNotificationModel.BookingStatus =
              booking.OriginalBookingStatus;
            requestPermissionNotificationModel.BookingPaidStatus =
              bookingStatusModel.IsPaid;

            requestPermissionNotificationModel.RequestPermissionNotificationType =
              RequestPermissionNotificationType.CancelBookingPermission;

            var requestPermissionNotificationItems: RequestPermissionNotificationItem[] =
              [];

            var bookingOrTransactionServiceItems = booking.BookingServices.filter(
              (b) => b.ItemType == BookingOrTransactionItemType.Service
            );

            var bookingOrTransactionPackageItems = booking.ClientPackages;

            if (bookingOrTransactionServiceItems) {
              bookingOrTransactionServiceItems.forEach((element, index) => {
                var bookingServiceClass: BookingServiceClass = element;

                var requestPermissionNotificationItem =
                  new RequestPermissionNotificationItem();

                requestPermissionNotificationItem.ItemType =
                  BookingOrTransactionItemType.Service;

                requestPermissionNotificationItem.ServiceId =
                  bookingServiceClass.ServiceId;

                requestPermissionNotificationItems.push(
                  requestPermissionNotificationItem
                );
              });
            }

            if (bookingOrTransactionPackageItems) {
              bookingOrTransactionPackageItems.forEach((element, index) => {
                var clientPackage: ClientPackage = element;

                var requestPermissionNotificationItem =
                  new RequestPermissionNotificationItem();

                requestPermissionNotificationItem.ItemType =
                  BookingOrTransactionItemType.Package;

                requestPermissionNotificationItem.PackageId =
                  clientPackage.OffersSettingId;

                requestPermissionNotificationItems.push(
                  requestPermissionNotificationItem
                );
              });
            }

            requestPermissionNotificationModel.RequestPermissionNotificationItems =
              requestPermissionNotificationItems;

            const modalRef = this.ngbModal.open(CheckRequestPermissionComponent, {
              size: 'md',
            });
            modalRef.componentInstance.message = response.Message;

            modalRef.componentInstance.RequestPermissionNotificationModel =
              requestPermissionNotificationModel;

            // this.btnLoading = false;

            modalRef.componentInstance.getPermissionNotificationId.subscribe(
              (RequestPermissionNotificationId: any) => {
                modalRef.close();
                let findBooking = this.CalendarEvent; //this.events.find((f) => f.Id == booking.Id);
                if (findBooking) {
                  findBooking.RequestPermissionNotificationId =
                    RequestPermissionNotificationId;
                }
                modalRef.close();
                this.OnMakeRequestPermissionDone(
                  booking.Id,
                  RequestPermissionNotificationId,
                  RequestPermissionNotificationType.CancelBookingPermission
                );
              }
            );
          } else {
            if (response.State == ResponseState.OTPError) {
              this.ClientNotificationsOTPError = true;
            }
            this.sharedService.ToastrError(response.Message);
            booking.BookingStatus = oldBookingStatus;
          }
        });
    }
  }

  OnMakeRequestPermissionDone(
    BookingId: number,
    RequestPermissionNotificationId: number,
    requestPermissionNotificationType: RequestPermissionNotificationType
  ) {
    if (
      this.signalRService.hubConnection.state != HubConnectionState.Connected
    ) {
      this.signalRService.StartSignalRConnection();
      this.signalRService.SignalRConnectionStartedSubject.subscribe(
        (hubConnection) => {
          this.hubConnection = this.signalRService.JoinCashierGroup(
            RequestPermissionNotificationId
          );
          this.HandleReplyRequestPermission(BookingId);
        }
      );
    } else {
      this.hubConnection = this.signalRService.JoinCashierGroup(
        RequestPermissionNotificationId
      );
      this.HandleReplyRequestPermission(BookingId);
    }
  }


  public HandleReplyRequestPermission = (BookingId: number) => {
    this.hubConnection.on(
      MagicStrings.NewReplyRequestPermissionNotification,
      (
        newReplyPermissionNotificationModel: NewReplyPermissionNotificationModel
      ) => {
        if (
          this.sharedService?.CurrentBranch
            ?.AllowUseRequestsPermissionsNotificationsSounds
        ) {
          this.sharedService.HandelPlayAudio(
            newReplyPermissionNotificationModel.requestPermissionNotificationType,
            newReplyPermissionNotificationModel.requestPermissionNotificationStatus
          );
        }
        if (
          newReplyPermissionNotificationModel.requestPermissionNotificationStatus ==
          RequestPermissionNotificationStatus.Accepted
        ) {
          var key = 'CancelBookingPermissionAcceptedSusccessfully.';

          var message = this.translate.instant(key);

          message += ' - ';
          message += this.translate.instant(
            'UserNameThatAcceptRequestPermission:'
          );
          message += newReplyPermissionNotificationModel.replyUserName;
          message += ' - ';
          message += this.translate.instant('AcceptanceDate:');
          message += formatDate(
            newReplyPermissionNotificationModel.replyDateTime,
            'dd-MM-yyyy',
            this.locale
          );
          message += ' - ';
          message += this.translate.instant('AcceptanceTime:');
          message += formatDate(
            newReplyPermissionNotificationModel.replyDateTime,
            'hh:mm a',
            this.locale
          );

          if (newReplyPermissionNotificationModel.supervisorNotes) {
            message += ' - ';
            message += this.translate.instant('SupervisorNotes:');
            message += newReplyPermissionNotificationModel.supervisorNotes;
          }

          message += '.';

          this.toaster.info(message);
        } else {
          let findBooking = this.CalendarEvent; // this.events.find((f) => f.Id == BookingId);
          if (findBooking) {
            findBooking.RequestPermissionNotificationId = null;
            findBooking.BookingStatus = findBooking.OriginalBookingStatus;
          }

          var key = 'CancelBookingPermissionRejected!';

          var message = this.translate.instant(key);
          message += ' - ';
          message += this.translate.instant(
            'UserNameThatRejectRequestPermission:'
          );
          message += newReplyPermissionNotificationModel.replyUserName;
          message += ' - ';
          message += this.translate.instant('RejectDate:');
          message += formatDate(
            newReplyPermissionNotificationModel.replyDateTime,
            'dd-MM-yyyy',
            this.locale
          );
          message += ' - ';
          message += this.translate.instant('RejectTime:');
          message += formatDate(
            newReplyPermissionNotificationModel.replyDateTime,
            'hh:mm a',
            this.locale
          );

          if (newReplyPermissionNotificationModel.supervisorNotes) {
            message += ' - ';
            message += this.translate.instant('SupervisorNotes:');
            message += newReplyPermissionNotificationModel.supervisorNotes;
          }

          message += '.';

          this.toaster.warning(message);
        }
      }
    );
  }

  openModalHandleBookingOTPComponent(e, booking: Booking) {

    const modalRef = this.ngbModal.open(
      ModalHandleTransactionOTPComponent,
      { size: 'md', backdrop: false }
    );

    modalRef.componentInstance.Form = {
      TransactionBookingId: booking.Id,
      TransactionOTPCode: booking.BookingOTPCode,
      ClientNotificationOTPId: booking.ClientNotificationOTPId,
      BookingOrTransactionClientId: booking.ClientId,
      BookingOrTransactionTotalPrice: booking.TotalNetPrice
    };

    modalRef.componentInstance.OTPChanged.subscribe(
      (response: OTPResponse) => {


        if (response && response.ClientNotificationOTPId && response.OTPCode) {

          booking.ClientNotificationOTPId = response.ClientNotificationOTPId;
          booking.BookingOTPCode = response.OTPCode;

          this.ClientNotificationsOTPError = false;
          this.UpdateBookingStatus(e, booking);
        }

      }
    );
  }


  CheckForNotifyClientOTP(booking: Booking): boolean {

    var payBookigOTP =
      this.sharedService.CurrentCompany?.AllowUseTheOTPSystemToNotifyClientsWhenPayBookingAndChangeBookingStatus;

    var clientNotificationOTPId = booking.ClientNotificationOTPId;
    var bookingOTPCode = booking.BookingOTPCode;

    if (payBookigOTP &&
      booking.BookingStatus == BookingStatus.WorkDone &&
      ((!clientNotificationOTPId || !bookingOTPCode) || this.ClientNotificationsOTPError)) {
      return true;
    }

    return false;
  }

  divName;
  printPage() {
    this.divName = 'printCalendarEventInfo';
    console.log(this.divName);

    let printContents = document.getElementById(this.divName).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    // this.divName = null;
  }
  convertEnumToArray() {
    this.bookingStatus = [];
    for (const [propertyKey, propertyValue] of Object.entries(BookingStatus)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      this.bookingStatus.push({ id: propertyValue, name: propertyKey });
    }
    console.log(this.bookingStatus);
  }

}
